import gql from 'graphql-tag'

/**
 * Mutation to create a new vehicle list for a given workspace.
 * Requires workspaceId, name, and type in the input.
 */
export const CREATE_VEHICLE_LIST_M = gql`
  mutation CreateVehicleList(
    $workspaceId: String!
    $cameraId: String
    $name: String!
    $type: VehicleListTypeEnum!
  ) {
    createVehicleList(
      createVehicleListInput: {
        workspaceId: $workspaceId
        cameraId: $cameraId
        name: $name
        type: $type
      }
    ) {
      code
      success
      message
      vehicleList {
        id
        workspaceId
        cameraId
        name
        type
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * Mutation to snapshot an existing vehicle list into a new list with a given name.
 * Creates a point-in-time copy of the source vehicle list's records.
 */
export const SNAPSHOT_VEHICLE_LIST_M = gql`
  mutation SnapshotVehicleList(
    $sourceVehicleListId: Int!
    $newName: String!
  ) {
    snapshotVehicleList(
      snapshotVehicleListInput: {
        sourceVehicleListId: $sourceVehicleListId
        newName: $newName
      }
    ) {
      code
      success
      message
      vehicleList {
        id
        workspaceId
        cameraId
        name
        type
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * Mutation to derive a new vehicle list from an existing one based on specified filter criteria.
 * This mutation explicitly defines all arguments inline for better transparency on what it takes.
 */
export const DERIVE_VEHICLE_LIST_M = gql`
  mutation DeriveVehicleList(
    $originalVehicleListId: String!
    $newVehicleListName: String!
    $timeRangeType: String!
    $timeRangePastRange: Float
    $timeRangePastUnit: String
    $timeRangeFrom: DateTime
    $timeRangeTo: DateTime
    $appearanceCountEnable: Boolean!
    $appearanceCountLowerBound: Float
    $appearanceCountUpperBound: Float
    $make: String
    $type: String
  ) {
    deriveVehicleList(
      deriveVehicleListDTO: {
        originalVehicleListId: $originalVehicleListId
        newVehicleListName: $newVehicleListName
        timeRange: {
          type: $timeRangeType
          pastRange: $timeRangePastRange
          pastUnit: $timeRangePastUnit
          from: $timeRangeFrom
          to: $timeRangeTo
        }
        appearanceCount: {
          enable: $appearanceCountEnable
          lowerBound: $appearanceCountLowerBound
          upperBound: $appearanceCountUpperBound
        }
        make: $make
        type: $type
      }
    ) {
      vehicleListId
      success
    }
  }
`
